import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

import {
  getAdminSelectedCompanyId,
} from "../../../../helpers/adminSelectors";

import AddressLabels from "./AddressLabels";

const Addresses = ({
  addressValues,
  onSaveAddressValues,
}) => {
  const companyId =
    useSelector(
      getAdminSelectedCompanyId
    );

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        border:
          "1px solid #e6e9ee",
        borderRadius: 1.5,
        p: {
          xs: 1.25,
          sm: 1.75,
        },
      }}
    >
      <AddressLabels
        companyId={companyId}
      />
    </Box>
  );
};

Addresses.defaultProps = {
  addressValues: null,
  onSaveAddressValues: null,
};

Addresses.propTypes = {
  addressValues:
    PropTypes.object,
  onSaveAddressValues:
    PropTypes.func,
};

export default Addresses;
